import modalService from '../utils/modalService'

/* Kaldırılan modal eklentisinin (2.0.1) `$modal` API'sinin ModalHost üzerindeki karşılığı. Mevcut çağrılar değişmez:
   `this.$modal.show(Component, props, params, events)` ve `this.$modal.hide(name)`.
   Yeni kod doğrudan `utils/modalService` (show(component, props, options) / close()) kullanır.

   Eski yerleşim korunur: başlık/alt bilgi yok, gövde dolgusuz, piksel genişlik ve sabit yükseklik, arka plana
   tıklama ve Esc kapatır (clickToClose). Köşe, gölge ve perde diğer pencerelerle aynı kabuktan gelir (modal.css);
   eski eklentinin 3px köşesi, kendi gölgesi ve %20 karartması bırakıldı. */

// Eski plugins/vue-modal.js `dynamicDefaults` + paket varsayılanı (width 600).
const LEGACY_DEFAULTS = {
  width: 600,
  minWidth: 700,
  height: 'auto',
  minHeight: 600,
  clickToClose: true
};

function toNumber(value) {
  if (typeof value === 'number') return value;
  if (typeof value === 'string' && /^\d+(\.\d+)?(px)?$/.test(value.trim())) return parseFloat(value);
  return null;
}

/* adaptive modda eski eklenti genişliği [minWidth, max(minWidth, viewport)] aralığına sıkıştırır;
   BS4 diyaloğu dar ekranda kendiliğinden daraldığı için yalnız üst sınır verilir. */
export function mapLegacyParams(params = {}) {
  const p = { ...LEGACY_DEFAULTS, ...params };

  const dialogStyle = {};
  const width = toNumber(p.width);
  if (width !== null) {
    dialogStyle.maxWidth = `${Math.max(toNumber(p.minWidth) || 0, width)}px`;
  } else if (typeof p.width === 'string' && p.width.trim().endsWith('%')) {
    dialogStyle.maxWidth = p.width.trim();
  }

  // Uzun içerik pencerenin içinde kayar; eski `scroll` kısa içerikte de boş bir kaydırma çubuğu basıyordu.
  const contentStyle = {
    overflowY: 'auto'
  };
  const height = toNumber(p.height);
  if (height !== null) {
    contentStyle.height = `${Math.max(toNumber(p.minHeight) || 0, height)}px`;
  }

  return {
    header: { show: false },
    footer: { show: false },
    size: '',
    closeOnEsc: p.clickToClose !== false,
    clickToClose: p.clickToClose !== false,
    dialogStyle,
    contentStyle,
    backdropStyle: null
  };
}

const legacyModal = {
  show(component, props = {}, params = {}, events = {}) {
    const bound = { ...(props || {}) };
    const handlers = events || {};

    if (typeof handlers['before-open'] === 'function') {
      bound.onOpen = () => handlers['before-open']({ name: 'vue-modal', params: {} });
    }
    if (typeof handlers['before-close'] === 'function') {
      bound.onClose = () => handlers['before-close']({ name: 'vue-modal', params: {} });
    }

    modalService.show(component, bound, mapLegacyParams(params || {}));
  },
  // Eski eklentide tüm dinamik modallar 'vue-modal' adını taşıyordu; tek host olduğu için ad yok sayılır.
  hide() {
    modalService.close();
  }
};

export { legacyModal };

export default {
  install(app) {
    app.config.globalProperties.$modal = legacyModal;
  }
};
